export const WHATSAPP_NUMBER = "919058520747";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent("Hi! I'd like to know more about Register to Digital.")}`;
export const EMAIL = "info@registertodigital.com";
export const ADDRESS = "Meerut, Uttar Pradesh, India";

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Try Now", to: "/try" },
  { label: "Error Scan", to: "/check" },
  { label: "My Data", to: "/my-data" },
  { label: "Features", to: "/features" },
  { label: "About", to: "/about" },
  { label: "Blog", to: "/blog" },
  { label: "Contact", to: "/contact" },
];

export const FEATURES = [
  { icon: "Camera", title: "Photo to Digital", desc: "Click a photo, get structured digital data in seconds." },
  { icon: "BookOpen", title: "All Register Types", desc: "Attendance, Stock, Visitor, OPD, Sales and more." },
  { icon: "Share2", title: "Export Anywhere", desc: "Export to PDF, Excel, Google Sheets, Word, WhatsApp." },
  { icon: "Languages", title: "Hindi + English", desc: "Bilingual OCR — works with हिंदी handwriting too." },
  { icon: "Cloud", title: "Cloud Storage", desc: "Access your registers from anywhere, anytime." },
  { icon: "ShieldCheck", title: "100% Secure", desc: "End-to-end encrypted, GDPR-friendly storage." },
];

export const STEPS = [
  { n: "01", title: "Click a photo", desc: "Open the app, point your camera at any register page and tap." },
  { n: "02", title: "AI digitizes it", desc: "Our OCR engine reads handwriting and structures every column." },
  { n: "03", title: "Export & share", desc: "Download as PDF, Excel, Sheets or share over WhatsApp instantly." },
];

export const INDUSTRIES = [
  { icon: "School", label: "Schools" },
  { icon: "Stethoscope", label: "Hospitals" },
  { icon: "Store", label: "Shops" },
  { icon: "Building2", label: "Offices" },
  { icon: "Warehouse", label: "Warehouses" },
  { icon: "Landmark", label: "Government" },
];

export const TESTIMONIALS = [
  {
    name: "Rajesh Kumar",
    role: "Principal, DAV Public School",
    quote: "We've digitized 12 attendance registers in a single week. Saved us hours every day.",
  },
  {
    name: "Dr. Priya Sharma",
    role: "Owner, Sharma Clinic",
    quote: "Our OPD register now lives in the cloud. I can pull up any patient's history in seconds.",
  },
  {
    name: "Amit Verma",
    role: "Manager, Verma Traders",
    quote: "Stock register to Excel in one click. Honestly, this should have existed years ago.",
  },
];

export const FAQS = [
  { q: "Do I need to type anything?", a: "No. Just take a photo. Our OCR reads handwritten and printed registers automatically." },
  { q: "Does it support Hindi registers?", a: "Yes. We support bilingual recognition for English and Hindi (Devanagari) handwriting." },
  { q: "Where is my data stored?", a: "On encrypted cloud storage hosted in India. You can export or delete your data anytime." },
  { q: "Can I export to Excel and Google Sheets?", a: "Yes — PDF, Excel, Google Sheets, Word and direct WhatsApp share are all supported." },
  { q: "Is there a free plan?", a: "Yes. The FREE plan lets you digitize 5 registers per month, no credit card required." },
];

export const PRICING = [
  {
    name: "Free",
    price: "0",
    period: "/month",
    summary: "For individuals trying us out.",
    features: ["5 registers per month", "PDF export only", "Email support", "1 user"],
    cta: "Start Free",
    popular: false,
  },
  {
    name: "Pro",
    price: "199",
    period: "/month",
    summary: "For growing teams and small businesses.",
    features: [
      "Unlimited registers",
      "PDF, Excel, Sheets, Word export",
      "WhatsApp sharing",
      "Priority support",
      "3 users",
      "5 GB cloud storage",
    ],
    cta: "Start Pro Trial",
    popular: true,
  },
  {
    name: "Business",
    price: "499",
    period: "/month",
    summary: "For organisations going fully paperless.",
    features: [
      "Everything in Pro",
      "Unlimited users",
      "Admin panel & roles",
      "API access",
      "50 GB cloud storage",
      "Dedicated support",
      "Custom branding",
    ],
    cta: "Talk to Sales",
    popular: false,
  },
];

export const BLOG_POSTS = [
  {
    slug: "indian-businesses-paperless-2026",
    title: "Why Indian Businesses Need to Go Paperless in 2026",
    excerpt: "Compliance, cost and climate — three reasons every Indian SME is rethinking the humble paper register this year.",
    date: "Dec 02, 2025",
    read: "6 min read",
    cover: "https://images.pexels.com/photos/6282081/pexels-photo-6282081.jpeg",
  },
  {
    slug: "digital-registers-schools-benefits",
    title: "Top 5 Benefits of Digital Registers for Schools",
    excerpt: "From parent transparency to NEP compliance, here is how digitization is quietly changing Indian classrooms.",
    date: "Nov 24, 2025",
    read: "5 min read",
    cover: "https://images.pexels.com/photos/7413920/pexels-photo-7413920.jpeg",
  },
  {
    slug: "ocr-changing-indian-businesses",
    title: "How OCR Technology is Changing Indian Businesses",
    excerpt: "A practical look at how on-device OCR has matured for Indic scripts and what it unlocks for the next decade.",
    date: "Nov 15, 2025",
    read: "7 min read",
    cover: "https://images.unsplash.com/photo-1667984390538-3dea7a3fe33d",
  },
];

export const REGISTER_TYPES = [
  "Attendance Register",
  "Visitor Register",
  "Stock Register",
  "Sales Register",
  "Expense Register",
  "OPD / Patient Register",
  "Employee Register",
  "Complaint Register",
  "Custom Register",
];

export const EXPORT_OPTIONS = ["PDF", "Excel", "Google Sheets", "Word", "WhatsApp"];

export const STATS = [
  { value: "1000+", label: "Registers digitized" },
  { value: "500+", label: "Happy customers" },
  { value: "99%", label: "OCR accuracy" },
  { value: "12+", label: "Register types" },
];
